export const SynopRequestType = Object.freeze({ "Station": 0, "Point": 1 });